//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { ACTION_UPDATE_FIND_IN_STORE_MODAL } from '@/scripts/store/actions/pdp'
import { coordinatesValidation } from '@/scripts/libs/store-locator'
import { createNamespacedHelpers } from 'vuex'
import {
  getGooglePlacesAutocomplete,
  mapLatLng,
  getAddressFromLatLng,
  mapAddressComponents,
} from '@/scripts/libs/google-maps'
import { minLength, required } from 'vuelidate/lib/validators'
import { getDeviceCoordinates } from '@/scripts/libs/geolocation'
import wcs from '@/scripts/libs/wcs'
import RbTextfield from '@/elements/forms/rb-textfield.vue'
import { WcsLocales } from '@/scripts/libs/wcs/types/locales'
import { QUEBEC } from '@/scripts/constants/eyewear-protection'

const { mapGetters: mapGettersPdp, mapActions: mapActionsPdp } = createNamespacedHelpers('pdp')
const { mapGetters: mapGettersEyewearProtection } = createNamespacedHelpers('eyewearProtection')
const { eyewearProtection, locale } = wcs.getStoreConfig()

export default {
  name: 'rb-google-autocomplete',
  components: {
    RbTextfield,
  },
  props: {
    isShipFromStore: {
      type: Boolean,
      default: false,
    },
    label: String,
    isClear: Object,
    disabled: Boolean,
    id: String,
    isGeolocationFeatureAvailable: {
      type: Boolean,
      default: false,
    },
    initialLocation: String,
    initialLongitude: Number,
    initialLatitude: Number,
    overrideLocale: String,
    avoidQuebecValidation: {
      type: Boolean,
      default: false,
    },
    iconClass: {
      type: String,
      default: '',
    },
    helper: {
      type: String,
      default: '',
    },
    helperError: {
      type: String,
      default: '',
    },
    isStoreAvailableInYourArea: {
      type: Boolean,
      default: true,
    },
    required: {
      type: Boolean,
      default: false,
    },
    error: {
      type: String,
      default: '',
    },
    initialState: {
      type: String,
      default: '',
    },
    isImmediateValidationEnabled: {
      type: Boolean,
      default: false,
    },
    textfieldAriaLabelError: {
      type: String,
      default: '',
    },
    textfieldAriaLabelDefault: {
      type: String,
      default: '',
    },
    focusOutEnabled: {
      type: Boolean,
      default: true,
    },
  },
  validations: {
    location: {
      required,
      minLength: minLength(1),
      coordinatesValidation,
      isStoreAvailableInYourArea: function () {
        return this.$props.isStoreAvailableInYourArea
      },
      quebecAddressValidation: function () {
        return this.quebecAddressValidation
      },
    },
  },
  data() {
    return {
      location: '',
      autocomplete: null,
      latitude: null,
      longitude: null,
      countryCode: undefined,
      state: '',
    }
  },
  computed: {
    ...mapGettersPdp(['findInStore']),
    ...mapGettersEyewearProtection(['isAtLeastOneCheckboxChecked']),
    getIcon() {
      return !this.findInStore.storeListState && !!this.iconClass ? this.iconClass : ''
    },
    quebecAddressValidation() {
      if (this.avoidQuebecValidation) {
        return true
      }
      if (
        (wcs.isCanada() &&
          !eyewearProtection.quebec.isPickupEnabled &&
          this.isAtLeastOneCheckboxChecked &&
          this.isQuebec) ||
        (this.isAtLeastOneCheckboxChecked && this.isQuebecInFindInStore)
      ) {
        return false
      }
      return true
    },
    isQuebec() {
      return this.state === QUEBEC
    },
    isQuebecInFindInStore() {
      const stateValue = this.findInStore.state
      return stateValue === QUEBEC
    },
  },
  watch: {
    $props: {
      handler() {
        if (this.isImmediateValidationEnabled) {
          this.$v.$touch()
        }
      },
      deep: true,
      immediate: true,
    },
    isClear(newValue) {
      if (newValue) {
        this.clearField()
      }
    },
    overrideLocale(newVal) {
      const options = {
        componentRestrictions: { country: WcsLocales.mapCountryCode(newVal) },
      }
      if (this.autocomplete) {
        this.autocomplete.setOptions(options)
      }
    },
    initialLongitude(value) {
      this.longitude = value
    },
    initialLatitude(value) {
      this.latitude = value
    },
  },
  mounted() {
    this.countryCode = this.overrideLocale
      ? WcsLocales.mapCountryCode(this.overrideLocale)
      : WcsLocales.mapCountryCode(locale)

    this.initAutoComplete(this.countryCode)

    if (this.initialLocation) {
      this.location = this.initialLocation
    }
    if (this.initialLatitude) {
      this.latitude = this.initialLatitude
    }

    if (this.initialLongitude) {
      this.longitude = this.initialLongitude
    }

    if (this.initialState) {
      this.state = this.initialState
    }

    if (this.findInStore.zipCode && !this.isShipFromStore) {
      this.location = this.findInStore.zipCode
      this.latitude = this.findInStore.latitude
      this.longitude = this.findInStore.longitude
    }

    if (this.isGeolocationFeatureAvailable) {
      getDeviceCoordinates(this.onGeolocationConfirm)
    }
  },
  methods: {
    ...mapActionsPdp({ updateFindInStoreModal: ACTION_UPDATE_FIND_IN_STORE_MODAL }),
    onGeolocationConfirm(data) {
      const {
        coords: { latitude, longitude },
      } = data

      const latLng = mapLatLng(latitude, longitude)

      getAddressFromLatLng(latLng, this.countryCode, (formattedAddress) => {
        this.location = formattedAddress
        this.latitude = latitude
        this.longitude = longitude
        const mapPlace = {
          latitude: this.latitude,
          longitude: this.longitude,
          value: this.location,
        }
        if (!!this.latitude && !!this.longitude) {
          this.$emit('currentPosition', mapPlace)
        }
      })
    },
    initAutoComplete(countryCode) {
      const input = this.$refs.location.$refs.field
      const options = {
        fields: ['formatted_address', 'geometry', 'name', 'address_components'],
        componentRestrictions: { country: countryCode.toLowerCase() },
      }
      if (input) {
        this.autocomplete = getGooglePlacesAutocomplete(input, options)
        this.autocomplete.addListener('place_changed', this.onPlaceChanged)
      }
    },
    onPlaceChanged() {
      const place = this.autocomplete.getPlace()
      const addressComponent = place.address_components
      const city = addressComponent?.find((component) => {
        return (
          component?.types[0] === 'locality' ||
          component?.types[0] === 'political' ||
          component?.types[0] === 'postal_town'
        )
      })

      if (place.geometry && place.geometry.location) {
        this.location = place.formatted_address
        this.latitude = place.geometry.location.lat()
        this.longitude = place.geometry.location.lng()

        const mapPlace = {
          latitude: this.latitude,
          longitude: this.longitude,
          requestAddress: this.location,
          addressComponents: mapAddressComponents(place?.address_components),
          city,
        }
        this.state = mapPlace.addressComponents?.state

        this.$emit('placeChanged', mapPlace)
      } else {
        return false
      }
    },
    getValue(e) {
      this.emitInvalidInput(this.$v.$invalid)
      if (!this.focusOutEnabled) {
        return
      }
      this.$v.$touch()
      this.location = e.target.value

      this.latitude = null
      this.longitude = null
      this.state = ''
      this.$emit('inputValue', { value: this.location, latitude: null, longitude: null })

      if (!e.target.value.length) {
        this.clearField()
      }
      this.type(e.target.value)
    },
    clearField() {
      this.$refs.location.value = ''
      this.location = ''
      this.$nextTick(() => {
        this.$v.$reset()
      })
      this.$emit('inputValue', { value: this.location, latitude: null, longitude: null })
    },
    type(inputValue) {
      if (!this.$v.$invalid) {
        this.$emit('type', {
          inputData: inputValue,
        })
      }
    },
    onSearchIconClick() {
      this.location = ''
      this.$emit('onSearchIconClick')
    },

    emitInvalidInput(isInvalid) {
      this.$emit('invalidInput', isInvalid)
    },
    focusInput() {
      this.$refs.location?.focus()
    },
  },
}
